import {Pipe, PipeTransform} from '@angular/core';
import { environment } from '@environments/environment';

@Pipe({
    name: 'env',
    standalone: false
})
class EnvPipe implements PipeTransform 
{
    transform(variable: string): string | null     {
        return environment[variable];
    }
}
export { EnvPipe };